type WorkspaceSectionFlags = {
  comuni: boolean;
  marketIntelligence: boolean;
};

/**
 * Public administration replaces Market Intelligence for the workspace.
 * The hidden section must stay out of the sidebar and out of direct URL access.
 */
export const workspaceSectionAccess = ({ comuni, marketIntelligence }: WorkspaceSectionFlags) => ({
  comuni,
  marketIntelligence: marketIntelligence && !comuni,
});
